<template>
    <div style="margin-top: 20px">
      <div class="banner-image img1" :style="{height: imgHeight + 'px', backgroundImage:'url(' + src1 + ')'}" ></div>

      <div class="banner-image" :style="{height: imgHeight + 'px', backgroundImage:'url(' + src2 + ')'}"  ></div>

    </div>
</template>

<script>
  export default {
    name: "index",
    data(){
      return {
        imgHeight:'',
        src1:require('../../../static/img/app_download.png'),
        src2:require('../../../static/img/mall_banner.png'),
      }
    },
    mounted() {
      let a = window.innerWidth
      this.imgHeight = (a * 280) / 3840
      console.log(this.imgHeight);
    }
  }
</script>

<style lang="scss" scoped>
  .image{
    width: 100%;
    background-size: cover;
  }
  .img1{
    margin-bottom:20px ;

  }
  .banner-image{
    width: 100%;
    height: 140px;
    overflow: hidden;
    background: center center no-repeat;
    background-size: cover;

  }

</style>



// WEBPACK FOOTER //
// src/components/Banner/index.vue